function initCountdown(root) {
  if (!root || root.getAttribute('data-countdown-init') === 'true') return;
  var endAttr = root.getAttribute('data-end');
  var durAttr = root.getAttribute('data-duration');
  var end = null;
  if (endAttr && endAttr.trim().length > 0) {
    var parsed = new Date(endAttr);
    if (!isNaN(parsed.getTime())) end = parsed.getTime();
  }
  if (!end && durAttr && !isNaN(Number(durAttr))) {
    end = Date.now() + Number(durAttr) * 1000;
  }
  if (!end) return;
  root.setAttribute('data-countdown-init', 'true');
  var dEl = root.querySelector('.countdown__num[data-unit="days"]');
  var hEl = root.querySelector('.countdown__num[data-unit="hours"]');
  var mEl = root.querySelector('.countdown__num[data-unit="minutes"]');
  var sEl = root.querySelector('.countdown__num[data-unit="seconds"]');
  var padDays = !root.querySelector('.countdown__container__dpd');
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    var now = Date.now();
    var diff = Math.max(0, end - now);
    var totalSec = Math.floor(diff / 1000);
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var minutes = Math.floor((totalSec % 3600) / 60);
    var seconds = totalSec % 60;
    if (dEl) dEl.textContent = padDays ? pad(days) : String(days);
    if (hEl) hEl.textContent = pad(hours);
    if (mEl) mEl.textContent = pad(minutes);
    if (sEl) sEl.textContent = pad(seconds);
    if (diff <= 0) {
      clearInterval(timer);
      var ev = new CustomEvent('countdown:finished');
      root.dispatchEvent(ev);

      root.classList.add('hidden');

    }
  }
  tick();
  var timer = setInterval(tick, 1000);
}
function initCountdownAll(rootScope) {
  var scope = rootScope || document;
  scope.querySelectorAll('.countdown').forEach(function (node) { initCountdown(node); });
}
document.addEventListener('DOMContentLoaded', function () { initCountdownAll(); });
document.addEventListener('shopify:section:load', function (e) { initCountdownAll(e.target || document); });
window.initCountdownAll = initCountdownAll;
